<template>
  <div class="columns is-multiline">
    <div class="column is-full">
      <admin-form-item v-if="val_arr">
        <div class="lp-linear-circle" v-for="val in val_arr"
             :class="{'selected':val.selected}"
             @click="clickLinear(val)">{{ val.label }}</div>
      </admin-form-item>
    </div>
    <div class="column is-full">
      <admin-form-item v-if="options">
        <div class="flex">
          <div>{{ options.range.min.val }} {{options.range.min.label}}</div>
          <div>~</div>
          <div>{{ options.range.max.val }} {{options.range.max.label}}</div>
        </div>
      </admin-form-item>
    </div>
  </div>
</template>

<script>
  import LpSortDropDown from '../../module/common/LpSortDropDown'
  import LpInputText from '../../module/common/LpInputText'
  import LpRadio from '../../module/common/LpRadio'
  import LpCheckBool from '../../module/common/LpCheckBool'
  import { SweetModal } from 'sweet-modal-vue'
  import LpModal from '../../module/common/LpModal.vue'
  import LpAddress from "../common/LpAddress";
  import LpCheckGroup from "../common/LpCheckGroup";
  import LpRegionDropDown from "../common/LpRegionDropDown";

  export default {
    props:['data', 'options'],
    components: {
    },
    watch: {

    },
    data () {
      return {
        val_arr: []
      }
    },
    created() {
      if(this.options){
        let min = this.options.range.min.val;
        let max = this.options.range.max.val;
        for(let i=min; i<=max; i++){
          this.val_arr.push({label: i, selected: false});
        }
      }
      if(this.data){
        for(let i=0; this.val_arr.length; i++){
          if(this.val_arr[i].label===this.data)
            this.val_arr[i].selected=true;
        }
      }
    },
    methods: {
      clickLinear(val){
        for(let i=0; i<this.val_arr.length; i++){
          this.val_arr[i].selected=false;
        }
        val.selected=true;
        this.$emit('update:data', val.label);
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/lp_main'

  .lp-linear-circle
    display inline-block
    margin-right 8px
    padding 4px 10px
    border 1px solid #eee
    border-radius 50%

  .selected
    background-color #ff5722
    color white
</style>
